$(function () {

  $('button.get-ticket').click(function (event) {
    event.stopPropagation();
  });

  $('.carousel-item').click(function () {
    window.location.href = $(this).data('show-path');
  });
})